import { Location } from 'history';
import { AD_INTERSCROLLER_END_MSG, AD_INTERSCROLLER_START_MSG } from 'mk/autogenerated/translations/AdSlotInterscroller.cd85c9ef00ddee29e39f503ca07af93d'
import { hasAds } from 'mk/bazaar/common/userUtils';
import AdSlot from 'mk2/containers/AdSlot/AdSlot';
import { supportsPassive } from 'mk2/helpers/detects';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './AdSlotInterscroller.mscss';

interface OwnProps {
    isMobile: boolean;
    location: Location;
    marginBottomWithAd?: 3 | 10 | 20 | 30;
    marginTopWithAd?: 3 | 10 | 20 | 30;
    requestUser: UserEntity;
    topFixedPos?: number;
    zone: string;
}

interface OwnState {
    adSlotStyle: {
        display: string;
    };
}

type Props = OwnProps;

export class AdSlotInterscroller extends React.PureComponent<Props, OwnState> {

    public static defaultProps: Partial<OwnProps> = {
        topFixedPos: 44, // height of page header (mobile)
    };

    private static scrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    // get Top/Bottom position of element according to browser viewport
    private static positionInViewport(elem) {
        const box = elem.getBoundingClientRect();
        const body = document.body;
        const docElem = document.documentElement;

        const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
        const clientTop = docElem.clientTop || body.clientTop || 0;

        const top = box.top + scrollTop - clientTop;
        const bottom = box.bottom + scrollTop - clientTop;

        return {
            top: Math.round(top),
            bottom: Math.round(bottom),
        };
    }

    private adSlot = React.createRef<HTMLDivElement>();
    private container = React.createRef<HTMLDivElement>();
    private startMsg = React.createRef<HTMLDivElement>();
    private endMsg = React.createRef<HTMLDivElement>();

    constructor(props) {
        super(props);
        this.state = {adSlotStyle: {
            display: 'none',
        }};
    }

    public render() {
        const {
            location,
            marginBottomWithAd,
            marginTopWithAd,
            requestUser,
            topFixedPos,
            zone,
        } = this.props;

        if (!this.showOnThisDevice() || (!hasAds(requestUser))) {
            return null;
        }

        return (
            <div className={styles.AdSlotInterscroller}>
                <div
                    className={styles.AdSlotInterscroller__msg}
                    style={{paddingTop: marginTopWithAd}}
                    ref={this.startMsg}
                >
                    <div className={styles.AdSlotInterscroller__msg__text}>
                        {AD_INTERSCROLLER_START_MSG}
                    </div>
                </div>
                <div
                    className={styles.AdSlotInterscroller__outer}
                    ref={this.container}
                    style={{height: topFixedPos ? `calc(100vh - ${topFixedPos}px)` : '100vh'}}
                >
                    <div className={styles.AdSlotInterscroller__inner_rel} />
                    <div
                        className={styles.AdSlotInterscroller__inner_abs}
                        ref={this.adSlot}
                        style={{
                            top: topFixedPos || 0,
                            position: 'fixed',
                            height: topFixedPos ? `calc(100vh - ${topFixedPos}px)` : '100vh',
                            ...this.state.adSlotStyle,
                        }}
                    >
                        <AdSlot
                            zone={zone}
                            location={location}
                            marginTopWithAd={marginTopWithAd}
                            marginBottomWithAd={marginBottomWithAd}
                        />
                    </div>
                </div>
                <div
                    className={styles.AdSlotInterscroller__msg}
                    style={{paddingBottom: marginBottomWithAd}}
                    ref={this.endMsg}
                >
                    <div className={styles.AdSlotInterscroller__msg__text}>
                        {AD_INTERSCROLLER_END_MSG}
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        this.updateInterscrollerAdSlotStyle();

        // Update position of AdSlot if this container has been scrolled
        // or browser window has been resized
        window.addEventListener('scroll', this.updateInterscrollerAdSlotStyle, (supportsPassive() ? { passive: true, capture: false } : false) as any);
        window.addEventListener('resize', this.updateInterscrollerAdSlotStyle, (supportsPassive() ? { passive: true, capture: false } : false) as any);
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.updateInterscrollerAdSlotStyle, false);
        window.removeEventListener('resize', this.updateInterscrollerAdSlotStyle, false);
    }

    public UNSAFE_componentWillReceiveProps() {
        // Recompute position of AdSlot. Called if reflowTrigger has changed.
        this.updateInterscrollerAdSlotStyle();
    }

    private updateInterscrollerAdSlotStyle = () => {
        if (!this.container.current || !this.adSlot.current) {
            return;
        }
        const sbox = AdSlotInterscroller.positionInViewport(this.startMsg.current);
        const ebox = AdSlotInterscroller.positionInViewport(this.endMsg.current);
        const viewportHeight = window.innerHeight;
        const currentScrollTop = AdSlotInterscroller.scrollTop();
        const currentScrollBottom = currentScrollTop + viewportHeight;
        // if viewport displays the interscroller part
        if (sbox.bottom <= currentScrollBottom && currentScrollTop <= ebox.top) {
            this.setState({adSlotStyle: {display: 'block'}});
        } else {
            this.setState({adSlotStyle: {display: 'none'}});
        }
    };

    private showOnThisDevice() {
        const { isMobile, zone } = this.props;

        return isMobile
            ? !zone.endsWith('(Desktop)')  // ignoruj Desktop-only plochy na mobile
            : !zone.endsWith('(Mobile)');  // ignoruj Mobile-only plochy na desktope
    }
}

